import React, { useRef, useEffect, useState } from 'react';
import { MapPin, ArrowRight } from 'lucide-react';

const NewsletterSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setEmail('');
      setTimeout(() => setIsSubmitted(false), 3000);
    }
  };

  return (
    <section ref={sectionRef} className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/31176160/pexels-photo-31176160.jpeg"
          alt="Amalfi Coast"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-stone-900/80" />
      </div>

      {/* Content */}
      <div className="relative max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <h2
          className={`text-3xl md:text-4xl font-serif text-white mb-4 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Get insider tips in your inbox
        </h2>
        <p
          className={`text-white/70 mb-8 transition-all duration-700 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Occasional emails with new destinations, seasonal tips, and Italy travel inspiration. No spam, unsubscribe anytime.
        </p>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className={`flex flex-col sm:flex-row gap-3 max-w-md mx-auto transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            className="flex-1 px-5 py-3 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-white/50 transition-colors"
            required
          />
          <button
            type="submit"
            className="px-6 py-3 bg-white text-stone-900 rounded-full font-medium hover:bg-amber-50 transition-colors flex items-center justify-center gap-2"
          >
            {isSubmitted ? 'Subscribed!' : 'Subscribe'}
            {!isSubmitted && <ArrowRight className="w-4 h-4" />}
          </button>
        </form>

        {/* Location Badge */}
        <div
          className={`mt-12 flex items-center justify-center gap-2 text-white/50 transition-all duration-700 delay-300 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <MapPin className="w-4 h-4" />
          <span className="text-sm">Amalfi Coast, Italy</span>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
